import './App.css';
import React, { useState, useEffect } from "react";
import { Analytics } from "@vercel/analytics/react"

// --- DEBUG MODE FLAG ---
// Set to true to show debugging information (e.g., screen resolution)
// Set to false for production or normal viewing
const DEBUG_MODE = false; // Change this to false to hide the resolution debug

function ResolutionDebug() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Call handler right away so state is initialised with current window size

    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures effect is only run on mount and unmount

  return (
    typeof windowSize.width !== 'undefined' && (
      <div className="fixed top-2 left-2 bg-black/70 text-yellow-300 text-xs p-2 rounded shadow-lg z-50 pointer-events-none">
        {`W: ${windowSize.width}px, H: ${windowSize.height}px`}
      </div>
    )
  );
}

function ClarenceFriend() {
  return (
    // Main container:
    // Mobile & Tablet (<1024px): min-height for content, allows vertical scroll, prevents horizontal. Background #1E1F37.
    // Desktop (>=1024px): fixed height/width, overflow hidden. Background #1E1F37.
    <div className="min-h-screen bg-[#1E1F37] lg:bg-[#1E1F37] overflow-x-hidden lg:relative lg:w-screen lg:h-screen lg:overflow-hidden">
      {DEBUG_MODE && <ResolutionDebug />}
      <Analytics/>
      {/* Desktop Background Image (Full screen, appears from 'lg' breakpoint upwards, contained to fit) */}
      <img
        src="https://www.emeeka.com/ClarenceFriend/FinalRence.png"
        alt="Clarence Friend Background"
        className="hidden lg:block absolute inset-0 w-full h-full object-contain"
        draggable={false}
      />

      {/* Content Wrapper */}
      {/* Mobile & Tablet: Column layout, items centered. */}
      {/* Desktop: Absolute positioning to overlay, flex to distribute space. */}
      <div
        className="flex flex-col items-center lg:items-stretch lg:absolute lg:inset-0 lg:flex lg:flex-col lg:justify-between"
        style={{ fontFamily: 'Gluten, Impact, sans-serif', fontWeight: 'normal' }}
      >
        {/* Top Section: Logo */}
        {/* Mobile & Tablet: Centered logo, padding top/bottom. */}
        {/* Desktop: Logo positioned to the left (25% padding on this container). */}
        <div className="w-full flex justify-center lg:justify-start pt-6 pb-3 lg:pt-0 lg:mt-0 lg:pl-[25%]">
          <img
            src="https://www.emeeka.com/ClarenceFriend/ClareneFriendSpace.png"
            alt="Clarence Friend Title"
            // Responsive width for the logo image
            className="drop-shadow-lg w-1/2 max-w-[200px] md:max-w-[280px] lg:w-[12vw] lg:min-w-[120px] lg:max-w-[360px] h-auto"
            draggable={false}
          />
        </div>

        {/* Middle Section: Main Image (Mobile & Tablet Only - hidden on 'lg' and up) */}
        {/* Appears on screens smaller than 'lg'. Centered with padding and vertical margin. */}
        <div className="w-full px-4 lg:hidden my-4">
          <img
            src="https://www.emeeka.com/ClarenceFriend/FinalRence.png"
            alt="Clarence Friend"
            className="w-full h-auto object-contain max-h-[50vh] md:max-h-[65vh] mx-auto" // max-h to control size, mx-auto for centering
            draggable={false}
          />
        </div>

        {/* Bottom Section: Text Content */}
        {/* Desktop: Uses flex properties from parent to push to bottom. */}
        <div className="w-full lg:flex-1 lg:flex lg:items-end">
          <div
            // Mobile & Tablet styles: Navy background, light text, yellow border.
            // Desktop styles: Semi-transparent black background, pinkish text/border.
            className="bg-[#191970] text-gray-100 border-4 border-yellow-400 rounded-3xl p-6 mx-4 my-4
                       lg:bg-black/40 lg:text-[#FF9783] lg:border-[#FF9783] lg:rounded-[2.5rem] 
                       lg:p-6 lg:drop-shadow-lg lg:backdrop-blur-sm 
                       lg:mb-20 lg:ml-8 xl:lg:mb-28 xl:lg:ml-16 lg:w-[20vw] lg:max-w-2xl 
                       transition-all duration-300"
          >
            <p className="text-lg">
              <span className="font-normal underline">About Clarence</span><br />
              Rence is a woolly pig, his biggest fear is being unpicked. Born in Peru, he walked to the US. Now he lives on the Solana blockchain. Come with Rence to the Moon.<br /><br />
              <span className="font-normal underline">How to buy</span><br />
              Create a wallet. Visit <a href="https://phantom.app" target="_blank" rel="noopener noreferrer" className="underline font-normal text-yellow-300 lg:text-[#FF9783]">phantom.app</a>. Get some SOL. Swap SOL for $RENCE<br /><br />
              <span className="font-normal underline">Tokenomics</span><br />
              Pumpfun tokenomics - Total supply 999,999,999.<br /><br />
            </p>
          </div>
        </div>
      </div>

      {/* Global styles: Ensure no horizontal scroll on body for mobile/tablet, and desktop overflow hidden */}
      <style jsx global>{`
        body, html {
          margin: 0;
          padding: 0;
        }
        body {
          overflow-x: hidden; /* Prevent horizontal scroll globally */
        }
        /* #root is the typical ID for Create React App projects */
        #root { 
          min-height: 100vh; /* Ensure app container takes at least full viewport height for scrolling content */
        }

        @media (min-width: 1024px) { /* Tailwind's 'lg' breakpoint (1024px) */
          body, html, #root {
            height: 100%;
            overflow: hidden; /* No scroll on desktop */
          }
        }
      `}</style>
    </div>
  );
}

export default ClarenceFriend;
